<section class="duna-directory-list">
  <header class="list-header">
    <div class="list-title">
      <mat-icon>location_on</mat-icon>
      <h2>Lokationer</h2>
      @if (totalCount || displayedRows.length) {
      <span class="list-count">{{ getCountLabel() }}</span>
      }
    </div>
    <mat-form-field
      appearance="outline"
      class="list-search"
      subscriptSizing="dynamic"
    >
      <mat-label>Søg navn, antal brandmænd, status eller fremgang</mat-label>
      <input
        matInput
        [ngModel]="locationSearch"
        (ngModelChange)="onLocationSearchChange($event)"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </header>

  @if (loading) {
  <mat-progress-bar mode="indeterminate" class="list-progress"></mat-progress-bar>
  }

  @if (loadError) {
  <p class="list-empty list-empty--error">{{ loadError }}</p>
  }

  @if (!loadError && displayedRows.length) {
  <div class="directory" role="list">
    <div class="directory-header">
      <span class="directory-header-avatar"></span>
      <button
        type="button"
        class="directory-header-sort directory-header-identity"
        (click)="onSortHeaderClick('identity', $event)"
      >
        Navn
        <mat-icon class="sort-icon">{{ sortIcon('identity') }}</mat-icon>
      </button>
      <button
        type="button"
        class="directory-header-sort directory-header-meta"
        (click)="onSortHeaderClick('meta', $event)"
      >
        Brandmænd
        <mat-icon class="sort-icon">{{ sortIcon('meta') }}</mat-icon>
      </button>
      <button
        type="button"
        class="directory-header-sort directory-header-stamp"
        (click)="onSortHeaderClick('stamp', $event)"
      >
        Status
        <mat-icon class="sort-icon">{{ sortIcon('stamp') }}</mat-icon>
      </button>
      <button
        type="button"
        class="directory-header-sort directory-header-progress"
        (click)="onSortHeaderClick('progress', $event)"
      >
        Tilmeldte
        <mat-icon class="sort-icon">{{ sortIcon('progress') }}</mat-icon>
      </button>
      <span class="directory-header-action"></span>
    </div>
    @for (row of displayedRows; track row.guid) {
    <div
      class="directory-row"
      role="listitem"
      (click)="onLocationRowClick(row)"
    >
      <app-duna-profile-image
        [obfuscatedName]="row.profileImageObfuscatedName"
        [fallbackInitials]="row.initials"
        [size]="40"
        [canEdit]="false"
        [scopeType]="'location'"
        [scopeId]="row.locationId"
        [entityUuid]="row.guid"
        [entityKind]="'location'"
      ></app-duna-profile-image>
      <div class="row-identity">
        <span class="row-name">{{ row.location.locations_name }}</span>
        @if (row.location.clean_name) {
        <span class="row-subtitle">{{ row.location.clean_name }}</span>
        }
      </div>
      <div class="row-meta row-meta--count">
        <mat-icon class="meta-icon">people</mat-icon>
        <span>{{ row.firefighterCount }}</span>
      </div>
      <div class="row-stamp">
        <span class="status-pill">{{ row.okPercentage }}%</span>
      </div>
      <div class="row-progress">
        <app-duna-user-progress-label
          [registeredPercentage]="row.registeredPercentage"
          [progressPercentage]="row.progressPercentage"
          [showBreakdown]="false"
          [compact]="true"
          aggregateContext="location"
          (click)="$event.stopPropagation()"
        ></app-duna-user-progress-label>
      </div>
      <mat-icon class="row-chevron">chevron_right</mat-icon>
    </div>
    }
  </div>
  } @else if (!loading && !loadError) {
  <p class="list-empty">
    {{
      locationSearch
        ? 'Ingen lokationer matcher søgningen'
        : 'Ingen lokationer fundet'
    }}
  </p>
  }

  <mat-paginator
    [length]="totalCount"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChange($event)"
    aria-label="Vælg side"
  ></mat-paginator>
</section>
